import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Col, Form, Modal, Row, Select} from "antd";
import {ErrorResponseData} from "../../../../models/core/response";
import {AxiosError} from "axios";
import {useRequiredLayers} from "../../../../utils/context";
import {MissingItemsControllerContext} from "../missing.items.controller";
import {MissingItemsStoreContext} from "../missing.items.store";

interface MissingItemsAddAllAvailableModalProps {
    visible: boolean;
    onClose: () => void;
}
export const AddAllAvailableModal: React.FC<MissingItemsAddAllAvailableModalProps> = ({visible, onClose}) => {
    const {store, controller} = useRequiredLayers(MissingItemsStoreContext, MissingItemsControllerContext)
    const {t} = useTranslation("translation", {useSuspense: false});
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            visible={visible}
            confirmLoading={loading}
            title={t("WISH_LIST.ADD_ALL_AVAILABLE_TO_BASKET")}
            okText={t("WISH_LIST.ADD_TO_ORDER")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            onCancel={() => {
                onClose();
                form.resetFields();
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name={"wish_list_form"}
                onFinish={() => form
                    .validateFields()
                    .then(values => {
                        setLoading(true);
                        controller.addAllToCart(values)
                            .then(
                                () => {
                                    form.resetFields();
                                    return onClose();
                                },
                                (e: AxiosError<ErrorResponseData>) => {
                                    if (e.response?.data.fields) {
                                        form.setFields(e.response?.data?.fields);
                                    }
                                })
                            .then(() => {
                            }, (e) => form.setFields(e.response?.data?.fields))
                            .finally(() => setLoading(false));
                    })
                }
            >
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="warehouses"
                            label={t("WAREHOUSES.TITLE")}
                            rules={[{required: true, message: t("FROM.ERROR.PLEASE_SELECT_VALUE")}]}

                        >
                            <Select
                                allowClear
                                defaultOpen
                                autoFocus
                                mode="multiple"
                                disabled={loading}
                                placeholder={t("WAREHOUSES.TITLE")}
                                getPopupContainer={trigger => trigger.parentElement}
                            >
                                {store.warehouses.map((warehouse) => (
                                    <Select.Option
                                        key={warehouse.id}
                                        value={warehouse.id}
                                    >
                                        {warehouse.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}